module.exports = __webpack_public_path__ + "img/bg-5-zhengfangxing.639c273c.png";